import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import { useMotionPreference } from './useMotionPreference';

export const useSmoothScroll = (disabled = false) => {
  const reduceMotion = useMotionPreference();
  useEffect(() => {
    if (reduceMotion || disabled) return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    let frame;
    function raf(time) {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    }

    frame = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, [reduceMotion, disabled]);
};
